export const TAGS_PERMISSIONS = {
  pageId: 74,
  name: 'Tags',
  path: 'tags',
} as const;
